import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { RequisitoGarantiaCantidad } from '../_models/requisito-garantia-cantidad';

@Injectable({
  providedIn: 'root'
})
export class RequisitoGarantiaCantidadService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/requisitosGarantiasCantidades';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as RequisitoGarantiaCantidad[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as RequisitoGarantiaCantidad[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as RequisitoGarantiaCantidad ) );
  }

  listadoPorIdRequisito( id: string ) {
    return this.httClient.get( this.rutServicio + '/requisitoGarantia/' + id ).pipe( map( res => res as RequisitoGarantiaCantidad[] ) );
  }

  listadoPorIdRequisitoHabilitado( id: string ) {
    return this.httClient.get( this.rutServicio + '/requisitoGarantia/' + id + '/enabled' ).pipe( map( res => res as RequisitoGarantiaCantidad[] ) );
  }

  crear( regCrear: RequisitoGarantiaCantidad ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as RequisitoGarantiaCantidad ) );
  }

  bulk( regCrear: RequisitoGarantiaCantidad[] ) {
    const auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    regCrear.map( x => {
      x.auditoriaUsuario = auditoriaUsuario;
    } );
    return this.httClient.post( this.rutServicio + '/bulk', regCrear ).pipe( map( res => res as RequisitoGarantiaCantidad ) );
  }

  actualizar( regActualizar: RequisitoGarantiaCantidad ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as RequisitoGarantiaCantidad ) );
  }
}
